/**
 * 标定参数-批量获取任务表单（选择要查询的标定类型）
 */
import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Radio } from 'antd';
import { SubDeviceTypeEnum } from '@/constants/deviceManage';

export interface CalibrationParamsQueryFormRef {
  getSubmitString: () => Promise<string | null>;
}

// 定义标定类型选项及其对应的设备ID
const calibrationTypes = [
  { 
    label: '前向一体机标定结果(多来目)', 
    value: 'camera_dlm',
    deviceId: SubDeviceTypeEnum.forwardIntegratedMachine_duolaimu 
  },
  { 
    label: '相机标定结果(园之云)', 
    value: 'camera_yzy',
    deviceId: SubDeviceTypeEnum.forwardIntegratedMachine_camera_yuanzhiyun 
  },
  { 
    label: '雷达标定结果(园之云)', 
    value: 'radar_yzy',
    deviceId: SubDeviceTypeEnum.forwardIntegratedMachine_radar_yuanzhiyun 
  },
  { 
    label: '拉线电机标定结果', 
    value: 'motor_zdw',
    deviceId: SubDeviceTypeEnum.wireMotor 
  },
  { 
    label: '组合惯导标定结果(阿奇)', 
    value: 'ins_aqi',
    deviceId: SubDeviceTypeEnum.ins_aqi 
  },
  {
    label: '安行前向相机标定结果',
    value: 'ax_forward_camera',
    deviceId: SubDeviceTypeEnum.ax_forward_camera
  },
  {
    label: '安行前向毫米波雷达标定结果',
    value: 'ax_forward_mmw_radar',
    deviceId: SubDeviceTypeEnum.ax_forward_mmw_radar
  },
  {
    label: '安行DMS相机标定结果',
    value: 'ax_dms_camera',
    deviceId: SubDeviceTypeEnum.ax_dms_camera
  },
  {
    label: '安行BSD相机标定结果',
    value: 'ax_bsd_camera',
    deviceId: SubDeviceTypeEnum.ax_bsd_camera
  },
];

const CalibrationParamsQueryForm = forwardRef<CalibrationParamsQueryFormRef, {}>((props, ref) => {
  const [selectedType, setSelectedType] = useState<string | undefined>(undefined);

  // 导出方法：获取表单数据的JSON字符串
  useImperativeHandle(ref, () => ({
    getSubmitString: async () => {
      // 检查是否已选择类型
      if (!selectedType) {
        return null;
      }

      // 获取当前选中的标定类型对应的设备ID
      const currentType = calibrationTypes.find(type => type.value === selectedType);
      if (!currentType) {
        return null;
      }

      // 只返回id字段
      return JSON.stringify({ id: currentType.deviceId });
    }
  }));

  // 切换标定类型
  const handleTypeChange = (e: any) => {
    setSelectedType(e.target.value);
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <span style={{ color: '#ff4d4f', marginRight: 4 }}>*</span>
        <span>请选择要查询的标定类型：</span>
      </div>
      <Radio.Group 
        value={selectedType} 
        onChange={handleTypeChange}
        buttonStyle="solid"
      >
        {calibrationTypes.map(type => (
          <Radio.Button key={type.value} value={type.value}>
            {type.label}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  );
});

export default CalibrationParamsQueryForm;
